import React, { useState } from "react";
import { Card, Descriptions, PageHeader, Button } from "antd";
// import { ImageViewer } from "react-image-viewer-dv";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { ImageViewOnly } from "../image/onlyImageVIew";

export const ViewAadharOTPData = (props) => {
  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openImageModal = (img) => {
    setImageOpen(true);
    setSelectedImage(img);
  };

  const closeImageModal = () => {
    setImageOpen(false);
    setSelectedImage(null);
  };
  const handleDownloadPDF = () => {
    const element = document.getElementById("view-profile");
    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("AadharOTPDetails.pdf");
    });
  };
  console.log("ViewAadharOTPData", props);

  return (
    <div id="view-profile">
      <div style={{ padding: "20px 0" }}>
        <PageHeader
          onBack={false}
          title="Aadhar OTP Details"
          extra={[
            <Button type="primary" onClick={handleDownloadPDF}>
              Download PDF
            </Button>,
            <span style={{ display: "flex" }}>
              <Card
                className="viewCard"
                hoverable
                style={{
                  width: "100px",
                  height: "100px",
                  marginRight: 4,
                  borderRadius: "50%",
                  display: "flex",
                }}
                cover={
                  // <ImageViewer>
                  <img
                    alt="example"
                    src={`data:image/png;base64,${props?.data?.profile_image}`}
                    style={{ width: 100, height: 100, borderRadius: "50%" }}
                    onClick={() =>
                      openImageModal(
                        `data:image/png;base64,${props?.data?.profile_image}`
                      )
                    }
                  />
                  // </ImageViewer>
                }
              ></Card>
            </span>,
          ]}
        >
          <Card className="viewCard">
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Aadhar Number</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.aadhaar_number
                    ? props?.data?.aadhaar_number
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Full Name</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.full_name
                    ? props?.data?.full_name
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">DOB</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.dob
                    ? moment(props?.data?.dob).format("DD/MM/YYYY")
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Gender</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.gender
                    ? props?.data?.gender == "F"
                      ? "Female"
                      : "Male"
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Care Of</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.care_of
                    ? props?.data?.care_of
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Mobile Verified</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.mobile_verified
                    ? props?.data?.mobile_verified
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            {props?.data?.address && props?.data?.address && (
              <>
                <Descriptions
                  size="small"
                  column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
                >
                  <Descriptions.Item
                    label={
                      <span
                        style={{ fontWeight: "bold" }}
                        className="sub-heading"
                      >
                        Country
                      </span>
                    }
                  >
                    <div style={{ fontSize: 16 }}>
                      {props?.data?.address?.country
                        ? props?.data?.address?.country
                        : "-"}
                    </div>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span
                        style={{ fontWeight: "bold" }}
                        className="sub-heading"
                      >
                        District
                      </span>
                    }
                  >
                    <div style={{ fontSize: 16 }}>
                      {props?.data?.address?.dist
                        ? props?.data?.address?.dist
                        : "-"}
                    </div>
                  </Descriptions.Item>
                </Descriptions>
                <Descriptions
                  size="small"
                  column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
                >
                  <Descriptions.Item
                    label={
                      <span
                        style={{ fontWeight: "bold" }}
                        className="sub-heading"
                      >
                        House
                      </span>
                    }
                  >
                    <div style={{ fontSize: 16 }}>
                      {props?.data?.address?.house
                        ? props?.data?.address?.house
                        : "-"}
                    </div>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span
                        style={{ fontWeight: "bold" }}
                        className="sub-heading"
                      >
                        Landmark
                      </span>
                    }
                  >
                    <div style={{ fontSize: 16 }}>
                      {props?.data?.address?.landmark
                        ? props?.data?.address?.landmark
                        : "-"}
                    </div>
                  </Descriptions.Item>
                </Descriptions>
                <Descriptions
                  size="small"
                  column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
                >
                  <Descriptions.Item
                    label={
                      <span
                        style={{ fontWeight: "bold" }}
                        className="sub-heading"
                      >
                        LOC
                      </span>
                    }
                  >
                    <div style={{ fontSize: 16 }}>
                      {props?.data?.address?.dist
                        ? props?.data?.address?.dist
                        : "-"}
                    </div>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span
                        style={{ fontWeight: "bold" }}
                        className="sub-heading"
                      >
                        PO
                      </span>
                    }
                  >
                    <div style={{ fontSize: 16 }}>
                      {props?.data?.address?.po
                        ? props?.data?.address?.po
                        : "-"}
                    </div>
                  </Descriptions.Item>
                </Descriptions>
                <Descriptions
                  size="small"
                  column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
                >
                  <Descriptions.Item
                    label={
                      <span
                        style={{ fontWeight: "bold" }}
                        className="sub-heading"
                      >
                        State
                      </span>
                    }
                  >
                    <div style={{ fontSize: 16 }}>
                      {props?.data?.address?.state
                        ? props?.data?.address?.state
                        : "-"}
                    </div>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={
                      <span
                        style={{ fontWeight: "bold" }}
                        className="sub-heading"
                      >
                        Street
                      </span>
                    }
                  >
                    <div style={{ fontSize: 16 }}>
                      {props?.data?.address?.street
                        ? props?.data?.address?.street
                        : "-"}
                    </div>
                  </Descriptions.Item>
                </Descriptions>
              </>
            )}
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                label={
                  <span style={{ fontWeight: "bold" }} className="sub-heading">
                    VTC
                  </span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props?.data?.address?.vtc ? props?.data?.address?.vtc : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Face Score</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.face_score
                    ? props?.data?.face_score
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Face Status</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.face_status
                    ? props?.data?.face_status
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Has Image</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.has_image
                    ? props?.data?.has_image
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Share Code</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.share_code
                    ? props?.data?.share_code
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Status</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.status
                    ? props?.data?.status
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Reason</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.type ? props?.data?.type : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Details</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.details
                    ? props?.data?.details
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Zip</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.zip ? props?.data?.zip : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Email Hash</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.email_hash
                    ? props?.data?.email_hash
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Mobile Hash</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.mobile_hash
                    ? props?.data?.mobile_hash
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </PageHeader>
        {imageOpen && (
          <ImageViewOnly
            imageOpen={imageOpen}
            imageUrl={selectedImage}
            onClose={closeImageModal}
          />
        )}
      </div>
    </div>
  );
};
